import { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
const SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

/** Carica lo script Cloudflare solo quando una pagina con un modulo pubblico lo richiede. */
const loadScript = () => {
  if (document.querySelector(`script[src="${SRC}"]`)) return;
  const s = document.createElement("script");
  s.src = SRC;
  s.async = true;
  s.defer = true;
  document.head.appendChild(s);
};

/** Widget Cloudflare Turnstile discreto: nessuna interazione richiesta, compare solo se Cloudflare lo ritiene necessario. */
export const Turnstile = ({ onToken, action = "public_form" }) => {
  const host = useRef(null);
  const widget = useRef(null);

  useEffect(() => {
    if (!SITE_KEY) return;
    loadScript();
    const render = () => {
      if (!window.turnstile || !host.current || widget.current !== null) return;
      widget.current = window.turnstile.render(host.current, {
        sitekey: SITE_KEY,
        action,
        execution: "render",
        appearance: "interaction-only",
        size: "flexible",
        theme: "light",
        language: "it",
        callback: onToken,
        "error-callback": () => onToken(""),
        "expired-callback": () => onToken(""),
        "timeout-callback": () => onToken(""),
      });
    };
    const timer = setInterval(() => { if (window.turnstile) { clearInterval(timer); render(); } }, 60);
    return () => {
      clearInterval(timer);
      if (widget.current !== null && window.turnstile) window.turnstile.remove(widget.current);
      widget.current = null;
    };
  }, [onToken, action]);

  if (!SITE_KEY) return null;
  return (
    <div data-testid="turnstile-block">
      <div ref={host} className="max-w-[320px]" data-testid="turnstile-widget" />
      <p className="text-[11px] text-mute leading-relaxed max-w-md">
        Questo modulo è protetto da Cloudflare Turnstile, usato solo per distinguere le persone dai bot.{" "}
        <a href="/cookie-policy" target="_blank" rel="noreferrer" className="link-u">Dettagli nella Cookie Policy</a>.
      </p>
    </div>
  );
};

export const resetTurnstile = () => window.turnstile?.reset();
